"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIEmptyState = _interopRequireDefault(require("UIComponents/empty/UIEmptyState"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes2 = require("../../constants/propTypes");

var getI18nKey = function getI18nKey(suffix) {
  return "FileManagerCore.permissions.stockImages." + suffix;
};

var StockImagesNoAccess = function StockImagesNoAccess(_ref) {
  var readOnlyReason = _ref.readOnlyReason,
      showIllustration = _ref.showIllustration;

  var primaryContent = _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey(readOnlyReason)
  });

  if (!showIllustration) {
    return _react.default.createElement("div", {
      className: "text-center"
    }, primaryContent);
  }

  return _react.default.createElement(_UIEmptyState.default, {
    primaryContent: primaryContent,
    secondaryContent: _react.default.createElement(_UIIllustration.default, {
      name: "keys"
    }),
    secondaryContentWidth: 150,
    reverseOrder: true
  });
};

StockImagesNoAccess.propTypes = {
  readOnlyReason: _propTypes2.readOnlyReasonProp,
  showIllustration: _propTypes.default.bool.isRequired
};
StockImagesNoAccess.defaultProps = {
  showIllustration: true
};
var _default = StockImagesNoAccess;
exports.default = _default;
module.exports = exports.default;